<template>
  <div>
    <digitization-project-storage-summary-text
      :project="project"
      class="mb-6"
    />
    <u-button
      leading-icon="i-ri-check-double-line"
      block
      @click="makeProjectPermanent"
      size="xl"
    >
      <span>Save FOREVER<sub class="reg-mark">&reg;</sub></span>
    </u-button>
    <div class="mb-6 mt-2 text-gray-500 text-sm">
      <digitization-auto-transfer-toggle check />
    </div>
    <digitization-extend-time-card
      :project="project"
      :upsell-tracking="upsellTracking"
    />
  </div>
</template>

<script setup>
  const emit = defineEmits(['made-permanent']);
  const props = defineProps({
    project: Object,
    upsellTracking: Object
  });

  const digitizationApi = useDigitizationApiService();
  const digitizationStore = useDigitizationStore();

  const isInitiatingMoveToStorage = ref(false);
  async function makeProjectPermanent() {
    try {
      isInitiatingMoveToStorage.value = true;
      await digitizationApi.transferToStorage(props.project);
      await waitFor(300); //give a chance for the api to update before getting the updated status
      await digitizationStore.refreshTransferStatus({project: props.project});

      emit('made-permanent');
    } catch (e) {
      if (e.response?.status === 409 && e.response._data?.error === 'another_in_progress') {
        useErrorToast().add({
          description: 'You currently have another project transferring to permanent storage. Please wait until that completes and try again.',
        });
      } else if (e.response?.status === 409 && e.response._data?.error === 'out_of_storage') {
        //update current user
        useSessionStore().getCurrentUser();
        props.project.userNeedsToBuyStorage = true;
      } else {
        useErrorToast().add();
      }
    } finally {
      isInitiatingMoveToStorage.value = false;
    }
  }
</script>
